// File: src/pages/CopyrightPage.js
import React from 'react';
import { useProfile } from '../context/ProfileContext';
import CopyrightPolicy202605 from "../components/miscellaneous/CopyrightPolicy202605.js";

const CopyrightPolicyPage = () => {
    const { isDarkMode } = useProfile();

    return (
        /* ✅ Dynamic background toggle */
        <div className={`min-h-screen transition-colors duration-500 ${isDarkMode ? 'bg-brand-black' : 'bg-white'}`}>
            <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                
                <div className="text-center">
                    {/* ✅ Heading colors synced with your typography language */}
                    <h1 className={`text-3xl font-extrabold sm:text-4xl uppercase tracking-tighter italic ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                        Copyright Policy
                    </h1>
                    <p className={`mt-4 text-lg font-bold tracking-widest uppercase text-[10px] ${isDarkMode ? 'text-brand-pink' : 'text-gray-500'}`}>
                        Last updated: May 16, 2026
                    </p>
                </div>

                {/* ✅ THE MAGIC LINE:
                    'prose-invert' handles all internal <h2>, <p>, <li> styling 
                    automatically when in dark mode, matching your project aesthetics perfectly.
                */}
                <div className={`mt-12 prose prose-lg mx-auto transition-colors duration-500 ${isDarkMode ? 'prose-invert' : ''}`}>
                    
                    <CopyrightPolicy202605 />

                </div>

            </div>
        </div>
    );
};

export default CopyrightPolicyPage;